import { mapState } from 'vuex';
import throttle from 'lodash/throttle';
import { searchIcons } from '@/utils/fontawesomeSearch.js';
export default {
  name: 'CoreIcons',
  props: {
    value: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    faStyle: {
      type: String,
      default: 'regular'
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      icons: [],
      icon: null,
      search: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    // initial () {
    //   return this.value;
    // },
    fontStyle() {
      if (this.faStyle === 'regular') {
        return 'far';
      } else if (this.faStyle === 'light') {
        return 'fal';
      } else {
        return 'fas';
      }
    },
    requiredRule() {
      return this.required ? [v => !!v || this.$i18n_t('Common.fieldRequired')] : [];
    }
  },
  watch: {
    value() {
      this.icon = this.value;
    },
    search: throttle(function (search) {
      this.icons = searchIcons(search);
    }, 250)
  },
  mounted() {
    this.icon = this.value;
  },
  methods: {
    faIcon(iconName) {
      iconName = iconName || '';
      if (iconName.trim() === '') {
        return 'fal fa-image';
      }
      return `${this.fontStyle} ${iconName.startsWith('fa-') ? iconName : `fa-${iconName}`}`;
    }
  }
};